var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageLayout } from '../../Components/PageLayout';
import { MainText } from '../../Components/BaseComponents/Typography';
import styles from './selectCardPage.module.css';
import { Arrow } from '../CheckOrder/SelectPaymentVariant/icons/arrow';
import { Card } from '../CheckOrder/SelectPaymentVariant/icons/card';
import { cardMask } from './utils';
export var SelectCard = function (_a) {
    var _b = _a.cards, cards = _b === void 0 ? [] : _b, onCardSelect = _a.onCardSelect;
    return (_jsxs(PageLayout, { children: [_jsxs(MainText, { children: ["Pay with Credit/Debit ", _jsx("br", {}), " Card"] }), _jsxs("div", __assign({ className: styles.wrapper }, { children: [cards.map(function (card) { return (_jsx(SelectItem, { onClick: function () { return onCardSelect === null || onCardSelect === void 0 ? void 0 : onCardSelect(card); }, title: cardMask(card.cardNumber) }, card.id)); }), _jsx(SelectItem, { onClick: function () { return onCardSelect === null || onCardSelect === void 0 ? void 0 : onCardSelect({ id: undefined }); }, title: "Pay with a new card" })] }))] }));
};
export var SelectItem = function (_a) {
    var disabled = _a.disabled, title = _a.title, onClick = _a.onClick;
    return (_jsxs("button", __assign({ onClick: disabled ? undefined : onClick, className: "".concat(styles.btn, " ").concat(disabled ? styles.disabled : '') }, { children: [_jsx("div", __assign({ className: styles.icon }, { children: _jsx(Card, {}) })), _jsx("div", __assign({ className: styles.main }, { children: title })), _jsx("div", __assign({ className: "".concat(styles.icon, " ").concat(styles.arrow) }, { children: _jsx(Arrow, {}) }))] })));
};
